// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v7c-t","colMin":"styles_colMin__1KWpj"};